import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@material-ui/core';

/**
 * @typedef {{
 *  title: string
 *  contentText: string
 *  confirmButtonText: string
 *  cancelButtonText: string
 *  onConfirmButtonClick: object
 *  onCancelButtonClick: object
 * } & (import('@material-ui/core/Dialog').DialogProps | {})} ConfirmDialogProps
 *  @param {{ isOpen: boolean } & ConfirmDialogProps} props
 */
export const ConfirmDialog = ({
    isOpen,
    title,
    contentText,
    confirmButtonText,
    cancelButtonText,
    onConfirmButtonClick,
    onCancelButtonClick,
    ...rest
}) => (
    <Dialog
        {...rest}
        open={isOpen}
        onClose={() => {}}
    >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText>{contentText}</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button
                variant="contained"
                size="small"
                onClick={onCancelButtonClick}
            >
                {cancelButtonText}
            </Button>
            <Button
                variant="contained"
                size="small"
                onClick={onConfirmButtonClick}
            >
                {confirmButtonText}
            </Button>
        </DialogActions>
    </Dialog>
);
